import { useLanguage } from "@/i18n";

export default function Marquee() {
  const { t } = useLanguage();
  const items = [...t.ribbon, ...t.ribbon];
  return (
    <div
      className="border-y border-line bg-surface/60 overflow-hidden py-4 select-none"
      data-testid="editorial-ribbon"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((item, i) => (
          <span
            key={i}
            className="flex items-center font-telemetry text-[11px] sm:text-xs uppercase tracking-[0.3em] text-sandmut"
          >
            <span className="px-6">{item}</span>
            <span className="w-1.5 h-1.5 bg-blaze rotate-45 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
